import { render, staticRenderFns } from "./bankPay.vue?vue&type=template&id=5039eb2e&scoped=true"
import script from "./bankPay.vue?vue&type=script&lang=js"
export * from "./bankPay.vue?vue&type=script&lang=js"
import style0 from "./bankPay.vue?vue&type=style&index=0&id=5039eb2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5039eb2e",
  null
  
)

export default component.exports